export const WebcamStream = 'webcam';
export const ScreenStream = 'screen';
export type VideoStreamType = typeof WebcamStream | typeof ScreenStream;

export interface VideoGrabber {
    grab: () => Promise<File | undefined>;
}
